<svg width="100%" height="100%" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.1762 16.4766C16.0681 16.4766 14.8648 18.8832 16.1296 20.5697C16.6695 21.2895 16.9613 22.1649 16.9613 23.0646V29.7416C16.9613 32.471 19.1738 34.6835 21.9032 34.6835H26.0648C28.7941 34.6835 31.0067 32.471 31.0067 29.7416V23.0647C31.0067 22.1649 31.2985 21.2895 31.8383 20.5697C33.1032 18.8832 31.8998 16.4766 29.7918 16.4766H18.1762ZM26.0646 21.7083C26.4789 21.7083 26.8146 22.0441 26.8146 22.4583V28.7007C26.8146 29.1149 26.4789 29.4507 26.0646 29.4507C25.6504 29.4507 25.3146 29.1149 25.3146 28.7007V22.4583C25.3146 22.0441 25.6504 21.7083 26.0646 21.7083ZM22.6529 22.4583C22.6529 22.0441 22.3172 21.7083 21.9029 21.7083C21.4887 21.7083 21.1529 22.0441 21.1529 22.4583V28.7007C21.1529 29.1149 21.4887 29.4507 21.9029 29.4507C22.3172 29.4507 22.6529 29.1149 22.6529 28.7007V22.4583Z"
        fill="white"
    />
    <path
        d="M28.1456 17.2555L27.561 15.5018C27.2888 14.6851 26.5245 14.1343 25.6637 14.1343H22.3043C21.4434 14.1343 20.6792 14.6851 20.4069 15.5018L19.8224 17.2555"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
    />
</svg>
